var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpInfo44 = function SvgHelpInfo44(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 17.69a7.2 7.2 0 0 1 11.194-5.99l.316.21a6.49 6.49 0 0 1-2.51 11.799V25.6a1.8 1.8 0 0 1-3.6 0v-3.11a2.29 2.29 0 0 1 2.29-2.29h.22a2.89 2.89 0 0 0 1.603-5.295l-.316-.21A3.6 3.6 0 0 0 18.4 17.69v.71a1.8 1.8 0 0 1-3.6 0v-.71ZM23.8 31a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4C12.059 4 4 12.059 4 22s8.059 18 18 18 18-8.059 18-18S31.941 4 22 4ZM7.6 22c0-7.953 6.447-14.4 14.4-14.4S36.4 14.047 36.4 22 29.953 36.4 22 36.4 7.6 29.953 7.6 22Z",
    fill: "currentColor"
  })));
};
export default SvgHelpInfo44;